/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import EventConst from '../constants/event.constant';
import capacitorService from '../services/capacitor.service';
import Emitter from '../bus';
import DeveloperConst from '../constants/developer.constant';
import DefConst from '../constants/def.constant';
import AppConst from '../constants/app.constant';
import { getSettingFromLocalstorage } from '../services/localstorage/getSettingFromLocalstorage';
import utilityService from '../services/utility.service';

const deviceConfigSetting = () => {
  const deviceSetting = {
    settings: {},
  };
  deviceSetting.getElevationApiKey = () => {
    if (!capacitorService.isCapacitorMobileApp && window.location.hostname === 'localhost') {
      return AppConst.googleMapsDevApiKey;
    }
    return AppConst.googleMapsProdApiKey;
  };
  deviceSetting.loadAsyncFile = () => {
    if (!window.google) {
      const fileref = document.createElement('script');
      fileref.setAttribute('type', 'text/javascript');
      fileref.setAttribute('src', AppConst.googleMapsApi + deviceSetting.getElevationApiKey());
      document.getElementsByTagName('head')[0].appendChild(fileref);
    }
  };
  deviceSetting.loadRequiredThings = async () => {
    utilityService.loadAloftAltitudeMap(
      DefConst.aloftCloudIndexMap,
      AppConst.dataMode.meteogram,
    );
    utilityService.loadAloftAltitudeMap(
      DefConst.aloftCloudIndexMap,
      AppConst.dataMode.routeprofile,
    );
    deviceSetting.loadAsyncFile();
  };
  deviceSetting.setDeviceSpecificSetting = () => {
    // Have to clear cache so that old charts can be redrawn as Device settings is changed
    utilityService.setSettingInLocalstorage(
      deviceSetting.settings,
      AppConst.localstorageConf.deviceSpecificSettingKey,
    );
    Emitter.emit(EventConst.deviceSettingChanged);
  };
  deviceSetting.setDefaultDeviceSpecificSetting = () => {
    deviceSetting.settings = {};
    DeveloperConst.controls.forEach((item) => {
      if (item.enabled) {
        deviceSetting.settings[item.key] = item.defaultValue;
      }
    });
    utilityService.setSettingInLocalstorage(
      deviceSetting.settings,
      AppConst.localstorageConf.deviceSpecificSettingKey,
    );
  };
  deviceSetting.loadDeviceSpecificConfig = async () => {
    const myPreviousDeviceSpecificSettings = getSettingFromLocalstorage(
      AppConst.localstorageConf.deviceSpecificSettingKey,
    );
    if (!myPreviousDeviceSpecificSettings) {
      deviceSetting.setDefaultDeviceSpecificSetting();
    } else {
      deviceSetting.settings = {};
      DeveloperConst.controls.forEach((item) => {
        if (item.enabled) {
          deviceSetting.settings[item.key] = utilityService.getSettingValue(
            myPreviousDeviceSpecificSettings[item.key],
            item.defaultValue,
          );
        }
      });
    }
    utilityService.loadRulesetInfo();
    Emitter.emit(EventConst.deviceSettingChanged);
  };
  return deviceSetting;
};

export default deviceConfigSetting();
